<template>
  <div>
    <h2 id="destinations" class="fs-24 font-medium">
      {{ title }}
    </h2>

    <tab-bar
      :country-structure="countryStructure"
      :selected-index.sync="selectedIndex" />

    <responsive>
      <template #lg>
        <destination-grid class="mt-8" :region="selectedRegion" />
      </template>
      <template #mdsm>
        <destination-slide class="mt-8" :region="selectedRegion" />
      </template>
    </responsive>
  </div>
</template>

<script>
import Responsive from '../../components/core/Responsive'
import DestinationGrid from './DestinationGrid'
import DestinationSlide from './DestinationSlide'
import TabBar from './TabBar'

export default {
  components: {
    TabBar,
    DestinationGrid,
    DestinationSlide,
    Responsive
  },
  data () {
    return {
      countryStructure: window.zubluDestination,
      selectedIndex: 0
    }
  },
  computed: {
    title () {
      return `Destinations in ${this.countryStructure.name}`
    },
    selectedRegion () {
      return this.countryStructure.children[this.selectedIndex]
    }
  }
}
</script>
